// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ContatosFidelizacao_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /contatos_fidelizacao/delete
 *
 * Deletes a loyalty contact by ID.
 */
import { registerContract } from './validate'

export interface ContatosFidelizacao_DeleteInput {
contatofidelizacao_id: number
}

registerContract('ContatosFidelizacao_DeleteInput', {
  contatofidelizacao_id: { type: 'number',  required: true },
})
